// extracted by mini-css-extract-plugin
module.exports = {"search":"search-f2a6b893","table":"table-d5864697","actions":"actions-74375f3d"};